import React, { useState, useLayoutEffect, useEffect, useRef } from "react";
import CKEditor from "@ckeditor/ckeditor5-react";
import InlineEditor from "custom-ckeditor5-build-inline-without-image";
import "./style/CkEditor.scss";

const CkEditor = (props) => {
  const {
    onChange,
    onFocus,
    onBlur,
    data,
    placeholder = "Escreva aqui o texto...",
  } = props;
  const [stateEditor, setStateEditor] = useState(data.text);
  const editorInstanceRef = useRef(null);
  const initialDataRef = useRef(data.text);

  const handleChange = (ev, editor) => {
    onChange(ev, editor.getData());
    setStateEditor(editor.getData());
  };

  const handleEditorReady = (editor) => {
    editorInstanceRef.current = editor;
    // Set initial data from ref to avoid reinitializing with updated prop
    if (initialDataRef.current !== editor.getData()) {
      editor.setData(initialDataRef.current);
    }
  };

  // Update editor data only if it actually changed, not on every prop update
  useLayoutEffect(() => {
    if (editorInstanceRef.current && data.text !== stateEditor) {
      initialDataRef.current = data.text;
      editorInstanceRef.current.setData(data.text);
      setStateEditor(data.text);
    }
  }, [data.id]); // Only trigger on id change, not on text change

  // Clean up editor instance on unmount
  useEffect(() => {
    return () => {
      if (editorInstanceRef.current) {
        editorInstanceRef.current.destroy().catch(() => {});
        editorInstanceRef.current = null;
      }
    };
  }, []);

  return (
    <div className="containerCkEditor">
      <CKEditor
        {...props}
        config={{ placeholder }}
        editor={InlineEditor}
        data={initialDataRef.current}
        onChange={(event, editor) => handleChange(event, editor)}
        onBlur={(event, editor) => onBlur()}
        onFocus={(event, editor) => onFocus()}
        onReady={(editor) => handleEditorReady(editor)}
      />
    </div>
  );
};

export default CkEditor;
